if (!customElements.get('multicolumn-section')) {
  customElements.define(
    'multicolumn-section',
    class MulticolumnSection extends HTMLElement {
      constructor() {
        super();
        this.zoomOpen = false;
        this.currentIndex = 0;
      }

      connectedCallback() {
        this.initShowMore();
        this.initZoom();
      }

      disconnectedCallback() {
        if (this.onKeydown) document.removeEventListener('keydown', this.onKeydown);
      }

      initShowMore() {
        if (this.dataset.showMore !== 'true') return;
        this.showMoreButton = this.querySelector('.multicolumn__show-more');
        this.showMoreWrapper = this.querySelector('[data-show-more-wrapper]');
        if (!this.showMoreButton) return;

        this.hiddenItems = Array.from(this.querySelectorAll('.multicolumn-list__item--hidden'));
        this.itemsPerLoad = parseInt(this.dataset.itemsPerLoad, 10) || 8;

        this.showMoreButton.addEventListener('click', () => this.revealMore());
        this.updateShowMoreButton();
      }

      revealMore() {
        const toReveal = this.hiddenItems.splice(0, this.itemsPerLoad);
        toReveal.forEach((item) => {
          item.classList.remove('multicolumn-list__item--hidden');
          item.removeAttribute('hidden');
        });
        this.updateShowMoreButton();
      }

      updateShowMoreButton() {
        if (this.hiddenItems.length === 0 && this.showMoreWrapper) {
          this.showMoreWrapper.hidden = true;
        }
      }

      initZoom() {
        if (this.dataset.zoom !== 'true') return;
        this.zoomModal = this.querySelector('.multicolumn-zoom');
        if (!this.zoomModal) return;

        this.slides = Array.from(this.zoomModal.querySelectorAll('.multicolumn-zoom__slide'));
        this.track = this.zoomModal.querySelector('.multicolumn-zoom__track');
        this.counter = this.zoomModal.querySelector('.multicolumn-zoom__counter-current');
        this.triggers = Array.from(this.querySelectorAll('[data-zoom-index]'));

        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            this.openZoom(parseInt(trigger.dataset.zoomIndex, 10) || 0);
          });
        });

        const closeButton = this.zoomModal.querySelector('.multicolumn-zoom__close');
        if (closeButton) closeButton.addEventListener('click', () => this.closeZoom());

        const prevButton = this.zoomModal.querySelector('.multicolumn-zoom__nav--prev');
        const nextButton = this.zoomModal.querySelector('.multicolumn-zoom__nav--next');
        if (prevButton) prevButton.addEventListener('click', () => this.moveZoom(-1));
        if (nextButton) nextButton.addEventListener('click', () => this.moveZoom(1));

        this.zoomModal.addEventListener('click', (event) => {
          if (
            event.target === this.zoomModal ||
            event.target.classList.contains('multicolumn-zoom__viewport') ||
            event.target.classList.contains('multicolumn-zoom__slide')
          ) {
            this.closeZoom();
          }
        });

        this.onKeydown = (event) => {
          if (!this.zoomOpen) return;
          if (event.key === 'Escape') this.closeZoom();
          else if (event.key === 'ArrowLeft') this.moveZoom(-1);
          else if (event.key === 'ArrowRight') this.moveZoom(1);
        };
        document.addEventListener('keydown', this.onKeydown);
      }

      openZoom(index) {
        this.currentIndex = index;
        this.updateZoom();
        this.zoomModal.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
        this.zoomOpen = true;
        const closeButton = this.zoomModal.querySelector('.multicolumn-zoom__close');
        if (closeButton) closeButton.focus();
      }

      closeZoom() {
        this.zoomModal.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
        this.zoomOpen = false;
        const opener = this.triggers[this.currentIndex];
        if (opener) opener.focus();
      }

      moveZoom(direction) {
        const total = this.slides.length;
        if (total === 0) return;
        this.currentIndex = (this.currentIndex + direction + total) % total;
        this.updateZoom();
      }

      updateZoom() {
        this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.currentIndex));
        if (this.track) this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
        if (this.counter) this.counter.textContent = this.currentIndex + 1;
      }
    }
  );
}
